import type { NativeFrame, NativeRenderer } from "./native-port";
import type { ImageStore } from "./image-store";
import { NativeCanvasRenderer } from "./native-canvas";
import { NativeRasterCache } from "./native-raster-cache";
/** Display-only progressive raster adapter; export and pixel hit tests stay synchronous. */
export class NativeDisplayCanvas implements NativeRenderer {
  readonly kind = "canvas2d";
  private raster: NativeRasterCache;
  private renderer: NativeCanvasRenderer;
  constructor(canvas: HTMLCanvasElement, images: ImageStore) {
    this.raster = new NativeRasterCache(images, true);
    this.renderer = new NativeCanvasRenderer(
      canvas,
      images,
      true,
      (document, node, density) => this.raster.get(document, node, density),
    );
  }
  draw(frame: NativeFrame) {
    this.raster.beginFrame(frame);
    this.renderer.draw(frame);
    this.raster.prune(
      new Set(
        frame.document.pages
          .find((p) => p.id === frame.document.activePageId)!
          .nodes.map((n) => n.id),
      ),
    );
  }
  dispose() {
    this.raster.dispose();
    this.renderer.dispose();
  }
}
